import styled from 'styled-components';

import { RELINKING_VARIANTS } from '../../constants';
import type { RelinkingBlockVariant } from '../../types';

export const ContentContainer = styled.div<{ $variant: RelinkingBlockVariant }>`
  padding: ${({ $variant }) =>
    ($variant === RELINKING_VARIANTS.METAREGIONS && '8px 2px 12px 8px') ||
    ($variant === RELINKING_VARIANTS.HOTELS && '8px')};
  background: #fff;

  box-sizing: border-box;
  height: ${({ $variant }) =>
    ($variant === RELINKING_VARIANTS.METAREGIONS && 'calc(100% - 120px)') ||
    ($variant === RELINKING_VARIANTS.HOTELS && '102px')};

  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  ${({ $variant }) =>
    $variant === RELINKING_VARIANTS.HOTELS &&
    `
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  `}
`;
